import React from "react";
import Flex from "src/sudokit/Layout/Flex";
import { Text } from "src/sudokit/components/Text";
import { SudoButton } from "src/sudokit/components/SudoButton";
import { ReferenceImageField as ReferenceImageFieldState } from "./useReferenceImage";

interface ReferenceImageFieldProps {
  field: ReferenceImageFieldState;
  label?: string;
}

const ReferenceImageField: React.FC<ReferenceImageFieldProps> = ({ field, label = "Reference Image (optional)" }) => (
  <div className="flex flex-col items-start gap-2 w-full text-left">
    <Text size="sm" weight="medium">
      {label}
    </Text>
    {field.previewUrl ? (
      <Flex align="center" gap={3}>
        <img src={field.previewUrl} alt="Reference" className="w-16 h-16 rounded-lg object-cover" />
        <Flex direction="column" align="flex-start" gap={1}>
          <Text size="xs">{field.fileName}</Text>
          <SudoButton type="button" variant="error" size="xsmall" onClick={field.remove}>
            Remove
          </SudoButton>
        </Flex>
      </Flex>
    ) : (
      <SudoButton
        type="button"
        variant="secondary"
        state={field.isConverting ? "loading" : "default"}
        disabled={field.isConverting}
        onClick={field.openPicker}
      >
        Upload reference image
      </SudoButton>
    )}
    <input ref={field.inputRef} type="file" accept={field.accept} hidden onChange={field.onFileChange} />
    {field.error && (
      <Text size="xs" color="danger-color">
        {field.error}
      </Text>
    )}
  </div>
);

export default ReferenceImageField;
